import { Button } from "@repo/ui/components/ui/button"
import { Body, H1 } from "@repo/ui/components/ui/typography"
import { useRouter } from "@tanstack/react-router"

function ErrorComponent() {
  const router = useRouter()

  // Re-runs route guards and loaders, so a passing network blip recovers
  // without a reload or a re-login.
  const handleRetry = () => {
    router.invalidate()
  }

  return (
    <div className="flex flex-col items-center justify-center size-full gap-2 p-6 text-center md:gap-4">
      <div className="space-y-2">
        <H1 weight="bold" className="text-3xl sm:text-4xl">
          Något gick fel.
        </H1>
        <Body className="text-muted-foreground">
          Försök igen. Om det fortfarande inte fungerar, starta om webbläsaren
          eller skicka ett mejl till rasmus@julo.se
        </Body>
      </div>
      <Button onClick={handleRetry}>Försök igen</Button>
    </div>
  )
}

export default ErrorComponent
